//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/brands/views/main/lan/es';
import editBrand from 'Modules/brands/views/.components/editBrand/lan/es';
import overview from 'Modules/brands/views/overview/lan/es';
import messageTemplatetab from 'Modules/brands/views/.components/messageTemplateTab/lan/es';
import createEditMessageTemplate from 'Modules/brands/views/.components/createEditMessageTemplate/lan/es';
import deleteMessageTemplate from 'Modules/brands/views/.components/deleteMessageTemplate/lan/es';
import deleteBrand from 'Modules/brands/views/.components/deleteBrand/lan/es';


locales = {
    ...locales,
    ...main,
    ...editBrand,
    ...overview,
    ...messageTemplatetab,
    ...createEditMessageTemplate,
    ...deleteMessageTemplate,
    ...deleteBrand,
};


export default locales;